import React, { Component } from 'react';
import DropdownButton from 'react-bootstrap/lib/DropdownButton';
import { Modal, Button, MenuItem } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import APP_DEFAULTS from '../../constants/app-defaults';
import StoreAPI from '../../apis/store';
import Menu from '../shared/dropdown-build-menu';
import MunicipalityService from '../../services/municipality-service';

class ZoneSelectModal extends Component {
    constructor(props) {
        super(props);
        this.defaultMunicipalty = {
            id: undefined,
            name: this.props.intl.formatMessage({
                id: 'select',
                defaultMessage: 'Select',
            }),
        };
        this.state = {
            selectedZone: {
                id: APP_DEFAULTS.zoneId,
                label: APP_DEFAULTS.zoneLabel,
            },
            selectedMunicipality: this.defaultMunicipalty,
            selectedZoneMunicipalities: [],
            availableZones: [],
        };

        this.setSelectedZone = this.setSelectedZone.bind(this);
        this.setSelectedMunicipality = this.setSelectedMunicipality.bind(this);
        this.handleEnd = this.handleEnd.bind(this);
        this.buildMenu = this.buildMenu.bind(this);
    }

    async componentDidMount() {
        const response = await StoreAPI.getGroupedStores();
        this.buildMenu(response.body.zones, response.body.data);
        this.setState((prevState) => {
            const selectedZoneMunicipalities = MunicipalityService.getAvailableMunicipalitiesByZoneId(prevState.selectedZone.id, this.props.availableZones, this.props.availableMunicipalities);
            return { selectedZoneMunicipalities };
        });
    }

    setSelectedZone = (id, text) => {
        this.setState((prevState) => {
            const selectedZoneMunicipalities = MunicipalityService.getAvailableMunicipalitiesByZoneId(id, this.props.availableZones, this.props.availableMunicipalities);
            return {
                selectedZone: { id, label: text },
                selectedMunicipality: this.defaultMunicipalty,
                selectedZoneMunicipalities,
            };
        });
    }

    setSelectedMunicipality = (id, text) => {
        this.setState({
            selectedMunicipality: { id, name: text },
        });
    }

    handleEnd = () => {
        this.props.onHide();
        this.props.setUserSelection(this.state.selectedZone.id, this.state.selectedMunicipality.id);
    };

    buildMenu(zones, stores) {
        const tmpMenu = Menu.buildMenu(zones, stores);
        this.setState((prevState) => ({ availableZones: tmpMenu }));
    }

    isModalValid() {
        return this.state.selectedZone.id !== undefined && (this.state.selectedMunicipality.id !== undefined || this.state.selectedZoneMunicipalities.length === 0);
    }

    render() {
        return (
            <Modal
                show={this.props.show}
                aria-labelledby="contained-modal-title-lg"
                id="modal-zone-selector"
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-lg">
                        <FormattedMessage id="modal-zoneSelect-title" defaultMessage="Hello" />
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                        <FormattedMessage id="modal-zoneSelect-text1" defaultMessage="default" />
                    </p>
                    <br />
                    <div className="row">
                        <div className="col-sm-3 col-12">
                            <DropdownButton id="dropdown-basic-button" as="button" className="button-cancel button-small" title={this.state.selectedZone.label}>
                                {this.state.availableZones.map((zone) => (
                                    <MenuItem
                                        as="button"
                                        className="button-secondary inv button-small"
                                        id={zone.id}
                                        key={zone.id}
                                        onClick={() => this.setSelectedZone(zone.id, zone.label)}
                                    >
                                        {zone.label}
                                    </MenuItem>
                                ))}
                            </DropdownButton>
                        </div>
                        {this.state.selectedZoneMunicipalities.length > 0 && (
                            <div className="col-sm-9 col-12">
                                <DropdownButton id="dropdown-basic-button" as="button" className="button-cancel button-small municipality-selector" title={this.state.selectedMunicipality.name}>
                                    {this.state.selectedZoneMunicipalities.map((municipality) => (
                                        <MenuItem
                                            as="button"
                                            className="button-secondary inv button-small"
                                            id={municipality.id}
                                            key={municipality.id}
                                            onClick={() => this.setSelectedMunicipality(municipality.id, municipality.name)}
                                        >
                                            {municipality.name}
                                        </MenuItem>
                                    ))}
                                </DropdownButton>
                            </div>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" disabled={!this.isModalValid()} style={{ marginRight: '5px' }} className="button-secondary button-small" onClick={() => this.handleEnd()}>
                        <FormattedMessage id="modal-zoneSelect-accept" defaultMessage="Accept" />
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default injectIntl(ZoneSelectModal);



/** WEBPACK FOOTER **
 ** ./src/components/zone/zone-select-modal.jsx
 **/